import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'reactstrap';

// import images
import img1 from '../../images/icon/smartphone_expenses_ocr.png';
import img2 from '../../images/icon/smartphone_approve.png';
import img3 from '../../images/icon/computer.png';
import img4 from '../../images/icon/cloud.svg';

//Import Components
import Counter2 from "../../components/Shared/counter2";
import FeatureTitle from './feature-title';

class Features extends Component {
    state = {
        counters : [
            { title : "", image : img1, postfix : "Rinde" },
            { title : "", image : img2, postfix : "Aprueba" },
            { title : "", image : img3, postfix : "Analiza" },
            { title : "", image : img4, postfix : "Integra" },
        ],
        isOpen: false, 
        collapse1 : true
    }
    render() {
        return (
            <React.Fragment>
                <Container>
                    {/* render feature title */}
                    <FeatureTitle maintitle="" title="Reinventamos la forma en que trabajas" desc="" badgeColor="primary" />
                    <Row id="counter">
                        {/* counter */}
                        <Counter2 counters={this.state.counters} />
                    </Row>
                </Container>
            </React.Fragment>
        );
    }
}

export default Features;